import React from 'react';
import { useIsDesktop } from '@/hooks/useMediaQuery';
import { AlertsPageDesktop } from './AlertsPage.Desktop';
import { AlertsPageMobile } from './AlertsPage.Mobile';

/**
 * Main Alerts Page component that switches between desktop and mobile layouts.
 * Uses screen width detection to determine which version to render.
 */
export const AlertsPage: React.FC = () => {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return <AlertsPageDesktop />;
  }

  return <AlertsPageMobile />;
};
